import * as React from 'react';
import {editDealroomProject, getProjectsByAssets,deleteProjectFromDealroom} from '../../../../store/actions';
import {connect} from 'react-redux';
import {DRProjectPreEditingFiltering} from "./helpers";
import {validationCheck} from "../../../helpers";


class CustomIconsAgGrid extends React.Component {

  onEdit = (id) => {
    const {params, projectsErrors, editDealroomProject} = this.props;
    const reslut = DRProjectPreEditingFiltering(params.data, params.colDef.projectData);

    if (!validationCheck(projectsErrors[params.data.projectIndex])) {
      editDealroomProject(reslut, id);
    }
  };

  onDelete = (id) => {
    const {deleteProjectFromDealroom, params} = this.props;
    const {removeChoosenProjects} = params.agGridReact.props;

    deleteProjectFromDealroom(id);
    removeChoosenProjects('choosenProjects',[])
  };

  render() {
    const {params} = this.props;

    return (
      <div>
        <ul className="list-actions">
          <li>
            <i
                className="btn-delete fa fa-trash fa-lg "
                onClick={() => this.onDelete(params.id)}
            />
          </li>
          <li>
            <i
                className="btn-edit fa fa-pencil fa-lg"
                onClick={() => this.onEdit(params.id)}
            />
          </li>
        </ul>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    schema: state.schemas.schema,
    projectsErrors: state.projects.projectsErrors,
  }
};

export default connect(mapStateToProps, {editDealroomProject, getProjectsByAssets,deleteProjectFromDealroom})(CustomIconsAgGrid);



// WEBPACK FOOTER //
// ./src/views/Dealroom/Dealroom/DealroomProject/CustomIconsAgGrid.js